import { useMutation } from '@apollo/client';
import { errorHandler } from 'utils/ErrorHandler';
import { REQUEST_INVOICE } from '..';

export function useMutaionRequestInvoice() {
  const [requestInvoice, { data }] = useMutation(REQUEST_INVOICE);

  const handleRequestInvoice = async (
    id: string,
    callback: (data: any) => void,
  ) => {
    try {
      const response = await requestInvoice({
        variables: {
          param: {
            settlementIds: [id],
          },
        },
      });

      if (response) {
        callback(response.data);

        window.showToast('정산 신청이 완료되었습니다.', 'success');
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleRequestInvoices = async (
    settlementIds: string[],
    callback: () => void,
  ) => {
    try {
      const response = await requestInvoice({
        variables: {
          param: {
            settlementIds,
          },
        },
      });

      if (response) {
        callback();

        window.showToast('정산 신청이 완료되었습니다.', 'success');
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return {
    requestResult: data,
    handleRequestInvoice,
    handleRequestInvoices,
  };
}
